import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PortfolioTableItemDetails } from '../views/PortfolioSummary/PortfolioTableItem';

interface PortfolioState {
  selectedPortfolio: PortfolioTableItemDetails | null;
}

const initialState: PortfolioState = {
  selectedPortfolio: null,
};

const portfolioSlice = createSlice({
  name: 'portfolio',
  initialState,
  reducers: {
    setSelectedPortfolio(state, action: PayloadAction<PortfolioTableItemDetails | null>) {
      state.selectedPortfolio = action.payload;
    },
    clearSelectedPortfolio(state) {
      state.selectedPortfolio = null;
    },
  },
});

export const { setSelectedPortfolio, clearSelectedPortfolio } = portfolioSlice.actions;
export default portfolioSlice.reducer;

export const selectSelectedPortfolio = (state: { portfolio: PortfolioState }) => state.portfolio.selectedPortfolio;
